export default __webpack_public_path__ + "static/icon-23-3-2f9d5b3a04ea04e2e0a83ec4e3c13b96.png";